import dayjs, { Dayjs } from "../../utils/dayjs"

export const FY_START_MONTH = 4 //April

export const DEFAULT_FY_LOWER_LIMIT_YEAR = 2025

export const ALL_QUARTERS: Array<{ key: string; value: string; }> = [
    { key: 'April-June', value: 'Q1' },
    { key: 'July-September', value: 'Q2' },
    { key: 'October-December', value: 'Q3' },
    { key: 'January-March', value: 'Q4' },
]

// This function tells us which FY are we currently in for any given date
export const getCurrentFYStartYear = (referenceDate: Dayjs = dayjs()): number => {
    const month = referenceDate.month() + 1 // dayjs month() is 0-indexed; convert to 1-12
    return month < FY_START_MONTH ? referenceDate.year() - 1 : referenceDate.year() // if month =  Jan/Feb/March => FY starts in previous calendar year. If month = April-December => FY starts in same calendar year
}

// This function tells us which quarter of the FY a given date falls in
export const getCurrentQuarterIndex = (referenceDate: Dayjs = dayjs()): number => {
    const month = referenceDate.month() + 1 // dayjs month() is 0-indexed; convert to 1-12

    if (month >= 4 && month <= 6) return 0
    if (month >= 7 && month <= 9) return 1
    if (month >= 10 && month <= 12) return 2
    return 3
}

export const getFiscalYearOptions = (
    lowerLimitStartYear: number = DEFAULT_FY_LOWER_LIMIT_YEAR,
    referenceDate: Dayjs = dayjs(),
): Array<{ key: string; value: string; }> => {
    const currentFYStartYear = getCurrentFYStartYear(referenceDate)

    const options: Array<{ key: string; value: string; }> = []

    for (let year = lowerLimitStartYear; year <= currentFYStartYear; year++) {
        options.push({
            key: `${year} - ${year + 1}`,
            value: `${year}`,
        })
    }
    return options
}

export const getQuartersForFiscalYear = (
    selectedYear: string,
    referenceDate: Dayjs = dayjs(),
): Array<{ key: string; value: string; }> => {
    if (!selectedYear) return ALL_QUARTERS
    const currentFYStartYear = getCurrentFYStartYear(referenceDate)
    if (Number(selectedYear) === currentFYStartYear) {
        const currentQuarterIndex = getCurrentQuarterIndex(referenceDate)
        return ALL_QUARTERS.slice(0, currentQuarterIndex + 1)
    }
    return ALL_QUARTERS
}
